import { get } from 'lodash';

class ClickFilterModel {
  static initialValues(clickFilterSetting) {
    return {
      enableRedirectSafePage: get(clickFilterSetting, 'enableRedirectSafePage') || false,
      enableRedirectPreviewPage: get(clickFilterSetting, 'enableRedirectPreviewPage') || false,
      customPagePreviewMode: !!get(clickFilterSetting, 'previewUrl') || false,
      previewUrl: get(clickFilterSetting, 'previewUrl') || '',
      redirectPreviewPageCondition: get(clickFilterSetting, 'redirectPreviewPageCondition') || [],
      previewPageWhitelistCondition: get(clickFilterSetting, 'previewPageWhitelistCondition') || [],
      customPageSafeMode: !!get(clickFilterSetting, 'safeUrl') || false,
      safeUrl: get(clickFilterSetting, 'safeUrl') || '',
      redirectSafePageCondition: get(clickFilterSetting, 'redirectSafePageCondition') || [],
      originalPageWhitelistCondition:
        get(clickFilterSetting, 'originalPageWhitelistCondition') || [],
    };
  }

  static parseBodyToRequest(clickFilterSettingInitial) {
    const { customPagePreviewMode, customPageSafeMode } = clickFilterSettingInitial || {};

    const body = {
      enableRedirectSafePage: get(clickFilterSettingInitial, 'enableRedirectSafePage') || false,
      enableRedirectPreviewPage:
        get(clickFilterSettingInitial, 'enableRedirectPreviewPage') || false,
      customPagePreviewMode: !!get(clickFilterSettingInitial, 'previewUrl') || false,
      previewUrl: get(clickFilterSettingInitial, 'previewUrl') || '',
      redirectPreviewPageCondition:
        get(clickFilterSettingInitial, 'redirectPreviewPageCondition') || [],
      previewPageWhitelistCondition:
        get(clickFilterSettingInitial, 'previewPageWhitelistCondition') || [],
      customPageSafeMode: !!get(clickFilterSettingInitial, 'safeUrl') || false,
      safeUrl: get(clickFilterSettingInitial, 'safeUrl') || '',
      redirectSafePageCondition: get(clickFilterSettingInitial, 'redirectSafePageCondition') || [],
      originalPageWhitelistCondition:
        get(clickFilterSettingInitial, 'originalPageWhitelistCondition') || [],
    };

    if (!customPageSafeMode) {
      body.safeUrl = '';
    }

    if (!customPagePreviewMode) {
      body.previewUrl = '';
    }

    return body;
  }
}

export default ClickFilterModel;
